import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  title: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
}

/**
 * Componente Header con título dinámico y botón de navegación
 */
export const Header: React.FC<HeaderProps> = ({ 
  title, 
  showBackButton = false, 
  onBackClick 
}) => {
  const navigate = useNavigate();

  /**
   * Maneja el click del botón atrás
   */
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="bg-secondary-800 border-b border-secondary-700 px-4 py-3 flex items-center justify-center relative">
      {showBackButton && (
        <button
          onClick={handleBackClick}
          className="absolute left-4 p-2 rounded-lg text-secondary-400 hover:text-primary-500 hover:bg-secondary-700 transition-all duration-200"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      )}
      <h1 className="text-lg font-semibold text-secondary-50">
        {title}
      </h1>
    </header>
  );
};

export default Header;